import PathFinder from "./PathFinder/PathFinder";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <PathFinder />
    </div>
  );
}
